import { Collapse, Form } from 'antd';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import * as THREE from 'three';
import Chip from '../../../../components/common/Chip/Chip';
import InputComponent from '../../../../components/common/InputComponent/InputComponent';
import SelectComponent from '../../../../components/common/SelectComponent/SelectComponent';
import RightMenuDesign from '../../../../components/house/RightMenuDesign/RightMenuDesign';
import { Icon } from '../../../../components/icon/icon';
import { DesignerPageContext } from '../../DesignerPage';
import './RightDoorMirrorDesignMenu.scss';
import i18n from '../../../../languages/i18n';
import { useTranslation } from 'react-i18next';
import { getInputType } from '../../../../utils/string/inputExpression';
import { openMessageError } from '../../../../components/common/Message/openMessageError';
import { openMessageSuccess } from '../../../../components/common/Message/openMessageSuccess';
import { GeometryUtils } from '../../../../utils/geometry/GeometryUtils';
import { openMessageWarning } from '../../../../components/common/Message/openMessageWarning';
const { Panel } = Collapse;

const RightDoorMirrorDesignMenu = ({ open, form, className, title }) => {
  const { t } = useTranslation();
  const designerPageContext = useContext(DesignerPageContext);
  const { insideLoaderRef, sceneManager, setTick, sceneRef, meshClickRef } =
    designerPageContext;

  const scaleTimerRef = useRef(null);

  const [handle, setHandle] = useState(false);
  const [doorMirrorModel, setDoorMirrorModel] = useState();
  const [doorMirrorSize, setDoorMirrorSize] = useState(0);

  useEffect(() => {
    if (designerPageContext?.meshClickRef?.current) {
      setDoorMirrorModel(designerPageContext.meshClickRef.current);

      const box = new THREE.Box3().setFromObject(
        designerPageContext.meshClickRef.current
      );
      const size = new THREE.Vector3();
      box.getSize(size);

      setDoorMirrorSize(size);
      form.setFieldsValue({
        widthMirror: Math.round(Math.max(size.x, size.z) * 1000),
        heightMirror: Math.round(size.y * 1000),
        depthMirror: Math.round(Math.min(size.x, size.z) * 1000),
      });
    }
  }, [open]);

  const handleChangeMirrorDoorHeight = async newHeight => {
    if (!insideLoaderRef.current || !sceneManager || !meshClickRef.current) {
      openMessageError({ content: t("Can't change height") });
      return;
    }

    if (newHeight > 1500) {
      openMessageWarning({
        content: t('Minimum height is {{x}}mm', { x: 100 }),
      });
      return;
    }

    try {
      const mesh = meshClickRef.current;
      const clone = mesh.clone();
      clone.scale.set(1, 1, 1);

      const meshSize = GeometryUtils.getSize(clone);

      const targetHeight = newHeight;
      const newScaleY = targetHeight / meshSize.y;

      mesh.scale.y = newScaleY;

      const meshOriginal = sceneManager.findGLTFByUuid(
        mesh.userData.originalModelUuid
      );

      meshOriginal.scale.y = newScaleY;

      setTick(tick => tick + 1);
      openMessageSuccess({ content: t('Height updated successfully') });
    } catch (error) {
      console.error('Error changing mirror height:', error);
      openMessageError({
        content: t('Cannot change height: {{message}}', {
          message: error.message,
        }),
      });
    }
  };

  // Debounced scale handler
  const debouncedValidate = useCallback(
    (changedValues, delay = 300) => {
      if (scaleTimerRef.current) {
        clearTimeout(scaleTimerRef.current);
      }

      scaleTimerRef.current = setTimeout(async () => {
        const name = Object.keys(changedValues)[0];
        const value = changedValues[name];
        const typeInput = getInputType(value);

        if (typeInput === 'number') {
          try {
            await form.validateFields([name]); // chỉ validate field này

            if (['widthMirror', 'heightMirror', 'depthMirror'].includes(name)) {
              handleChangeMirrorDoorHeight(value / 1000);
            }
          } catch (e) {}
        }

        setTimeout(async () => {
          await sceneManager?.calculateTotalCost?.({});
        }, 200);
      }, delay);
    },
    [sceneManager]
  );

  const formForDoorMirror = [
    {
      key: '1',
      label: <span className="text-title-medium">{t('Mirror')}</span>,
      children: (
        <div className="flex flex-col gap-16 items-start self-stretch">
          <Form.Item
            name={'widthMirror'}
            label={<span className="text-label-medium">{t('Length')}</span>}
            className="self-stretch"
          >
            <InputComponent
              type={'number'}
              addonAfter={<span className="text-body-medium">mm</span>}
              placeholder={t('Enter')}
              disabled
              // value={Math.round(
              //   Math.max(doorMirrorSize.x, doorMirrorSize.z) * 1000
              // )}
            />
          </Form.Item>
          <Form.Item
            name={'heightMirror'}
            label={<span className="text-label-medium">{t('Height')}</span>}
            className="self-stretch"
          >
            <InputComponent
              type={'number'}
              addonAfter={<span className="text-body-medium">mm</span>}
              placeholder={t('Enter')}
              // value={Math.round(doorMirrorSize.y * 1000)}
              // onChange={e => {
              //   if (getInputType(e.target.value) === 'number') {
              //     const newValue = parseInt(e.target.value);
              //     if (!isNaN(newValue) && newValue > 0) {
              //       // Debounce để tránh gọi quá nhiều lần
              //       if (window.drawerHeight) {
              //         clearTimeout(window.drawerHeight);
              //       }
              //       window.drawerHeight = setTimeout(() => {
              //         handleChangeMirrorDoorHeight(newValue);
              //       }, 200);
              //     }
              //   }
              // }}
            />
          </Form.Item>

          <Form.Item
            name={'depthMirror'}
            label={<span className="text-label-medium">{t('Thickness')}</span>}
            className="self-stretch"
          >
            <InputComponent
              type={'number'}
              addonAfter={<span className="text-body-medium">mm</span>}
              placeholder={t('Enter')}
              disabled
              // value={Math.round(
              //   Math.min(doorMirrorSize.x, doorMirrorSize.z) * 1000
              // )}
            />
          </Form.Item>
        </div>
      ),
    },
  ];

  return (
    <RightMenuDesign
      open={open}
      classNames={{
        root: 'top-16 ' + className,
        content: '!p-0 gap-0',
      }}
      header={
        <span className="text-title-large text-nowrap">
          {title ?? 'Tùy chỉnh'}
        </span>
      }
      content={
        <>
          <Form
            form={form}
            labelAlign="left"
            labelWrap
            labelCol={{ style: { minWidth: '101px' } }}
            colon={false}
            layout="horizontal"
            validateTrigger={'onChange'}
            onValuesChange={(changedValues, allValues) => {
              debouncedValidate(changedValues);
            }}
            className="left-cabinet-design-menu-body flex flex-col items-start overflow-hidden p-8 gap-8 grow self-stretch"
          >
            <Collapse
              expandIcon={({ isActive }) => (
                <span className="w-16 h-16 flex">
                  {isActive ? <Icon.ICExpandMore /> : <Icon.ICExpandLess />}
                </span>
              )}
              defaultActiveKey={['1', '2', '3']}
              onChange={() => {}}
              className="self-stretch overflow-auto"
              items={formForDoorMirror.map(item => ({
                ...item,
                onKeyDown: e => {
                  e.stopPropagation();
                },
              }))}
            />
          </Form>
        </>
      }
    />
  );
};

export default RightDoorMirrorDesignMenu;
